import { useClassified, useHardFacts } from "@/contexts/classified";
import { useI18n } from "@/shared/hooks";
import { FINANCIAL_LINK_PARTNER } from "@/shared/types";
const partnerLabelMap = {
    [FINANCIAL_LINK_PARTNER.MEDICIS]: "hardfacts.price.partner_link_medicis",
    [FINANCIAL_LINK_PARTNER.NEXTORIES_COMPAREZ]: "hardfacts.price.partner_link_nextories_comparez",
    [FINANCIAL_LINK_PARTNER.NEXTORIES_RESERVEZ]: "hardfacts.price.partner_link_nextories_reservez",
};
export const useMortgage = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const { t } = useI18n();
    const mortgage = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.sections) === null || _b === void 0 ? void 0 : _b.mortgage;
    const { financialLink } = ((_c = useHardFacts()) === null || _c === void 0 ? void 0 : _c.price) || {};
    if (!mortgage)
        return null;
    const { showMonthlyRateLabel, showRentLabel, formattedMonthlyAmount, region, } = mortgage;
    const monthlyPriceLinkLabel = formattedMonthlyAmount
        ? `${t("hardfacts.price.monthly_rate_new", {
            replace: {
                value: formattedMonthlyAmount,
            },
        })}`
        : t("hardfacts.price.financial_link");
    let priceLinkLabel = "";
    if (showMonthlyRateLabel) {
        priceLinkLabel =
            (financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName) === FINANCIAL_LINK_PARTNER.CM
                ? t("hardfacts.price.financial_link_credit_mutuel")
                : monthlyPriceLinkLabel;
    }
    else if (showRentLabel) {
        // In case we have partner links for some brands, we should translate their label; otherwise, we should show the default ones.
        const labelKey = (financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName) && partnerLabelMap[financialLink.partnerName]
            ? partnerLabelMap[financialLink.partnerName]
            : "hardfacts.price.rent_label";
        priceLinkLabel = t(labelKey);
    }
    return {
        id: (_d = mortgage.id) !== null && _d !== void 0 ? _d : "",
        federalStateGeoId: (_e = mortgage.federalStateGeoId) !== null && _e !== void 0 ? _e : "",
        price: (_f = mortgage.price) !== null && _f !== void 0 ? _f : 0,
        prov: (_g = mortgage.prov) !== null && _g !== void 0 ? _g : 0,
        zip: (_h = mortgage.zip) !== null && _h !== void 0 ? _h : "",
        city: (_j = mortgage.city) !== null && _j !== void 0 ? _j : "",
        country: (_k = mortgage.country) !== null && _k !== void 0 ? _k : "",
        // @ts-ignore
        region,
        subType: (_l = mortgage.subType) !== null && _l !== void 0 ? _l : "",
        showMonthlyRateLabel: (_m = mortgage.showMonthlyRateLabel) !== null && _m !== void 0 ? _m : false,
        showRentLabel: (_o = mortgage.showRentLabel) !== null && _o !== void 0 ? _o : false,
        monthlyAmount: (_p = mortgage.monthlyAmount) !== null && _p !== void 0 ? _p : null,
        originvariant: "WL_CDP",
        hasRentFinancialLink: financialLink && partnerLabelMap[financialLink === null || financialLink === void 0 ? void 0 : financialLink.partnerName],
        priceLinkLabel,
    };
};
